'use strict';(function Institute() {
  // Global selectors
  var cardsHolder = document.querySelector('[rel="js-cards-container"]');
  var loadSpinner = document.querySelector('[rel="js-load-spinner"]');
  var loadMoreContainer = document.querySelector('[rel="js-load-container"]');
  var elErrorNoResults = document.querySelector('[rel="js-error-no-results"]');
  var elErrorBadRequest = document.querySelector('[rel="js-error-bad-request"]');
  var sortNumber = document.querySelector('[rel="js-CardCountTotal"]');
  var urls = {
    next: '',
    all: '' };


  var templateObject = {
    heading: {
      element: 'div',
      classList: ['doctor-cards__heading'],
      contentKey: 'Group' },


    cards: {
      element: 'div',
      classList: ['doctor-cards'] },


    card: {
      element: 'div',
      classList: ['doctor-card'],
      children: [
      {
        element: 'a',
        classList: ['doctor-card__anchor'],
        attributes: [
        {
          attr: 'href',
          contentKey: 'DetailHref' }],


        children: [
        {
          element: 'img',
          classList: [],
          attributes: [
          {
            attr: 'src',
            contentKey: 'ImageSrc' },
          {
            attr: 'alt',
            contentKey: 'Name' }] },


        {
          element: 'div',
          classList: ['doctor-card__anchor-btn'],
          contentKey: 'ViewProfileText' }] },


      {
        element: 'div',
        classList: ['doctor-card__text'],
        children: [
        {
          element: 'a',
          classList: ['doctor-card__name'],
          contentKey: 'Name',
          attributes: [{
            attr: 'href',
            contentKey: 'DetailHref' }] },

        {
          element: 'div',
          classList: ['doctor-card__title'],
          contentKey: 'Title' },
        {
          element: 'p',
          classList: ['doctor-card__statement'],
          contentKey: 'ProfessionalStatement',
          children: [{
            element: 'a',
            classList: ['doctor-card__statement-link'],
            attributes: [{
              attr: 'href',
              contentKey: 'DetailHref' },
            {
              attr: 'doNotAdd',
              contentKey: 'HasReadMore' }],

            contentKey: 'ReadMoreText' }] }] }] },






    noLinkCard: {
      element: 'div',
      classList: ['doctor-card'],
      children: [
      {
        element: 'span',
        classList: ['doctor-card__anchor'],
        attributes: [],
        children: [
        {
          element: 'img',
          classList: [],
          attributes: [
          {
            attr: 'src',
            contentKey: 'ImageSrc' },
          {
            attr: 'alt',
            contentKey: 'Name' }] }] },




      {
        element: 'div',
        classList: ['doctor-card__text'],
        children: [
        {
          element: 'span',
          classList: ['u-h3'],
          contentKey: 'Name',
          attributes: [] },
        {
          element: 'div',
          classList: ['doctor-card__title'],
          contentKey: 'Title' },
        {
          element: 'p',
          classList: ['doctor-card__statement'],
          contentKey: 'ProfessionalStatement',
          children: [{
            element: 'span',
            classList: ['doctor-card__statement-link'],
            attributes: [] }] }] }] } };







  var ajax = function Ajax() {
    var xhr = void 0;

    function get(url, options) {
      if (!url || url.length === 0) {
        throw new Error('Bad Get URL');
      }

      xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

      xhr.onreadystatechange = function getStateChangeListener() {
        if (xhr.readyState === 4) {
          var responseText = JSON.parse(xhr.responseText);
          if (xhr.status === 200) {
            options.success(responseText);
          } else {
            console.error('An error occurred during your request!\n                status: ' +
            xhr.status + '\n                status text: ' +
            xhr.statusText);
            options.error(responseText);
          }
        }
      };
      xhr.send(options.data);
    }

    return {
      get: get };

  }();

  function createTemplateElement(obj) {var doctorObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = document.createElement(obj.element);

    // internal
    function checkAndSetParameter(param, func) {
      if (param) {for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {args[_key - 2] = arguments[_key];}
        func.apply(undefined, [param].concat(args));
      }
    }

    function setCssClass(cssClassList) {
      cssClassList.forEach(function (cssClass) {
        element.classList.add(cssClass);
      });
    }

    function setContent(key) {
      element.innerHTML = doctorObj[key];
    }

    function setAttributes(attributes) {
      // internal
      function hideTemplateElement(attr) {var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (attr === 'doNotAdd' && (value === false || value === 'false')) {
          element.classList.add('u-display--none');
        }
        return !value;
      }
      // internal
      function checkForAltAttr(attr, contentValue) {
        return attr !== 'alt' ? contentValue : 'Photo of ' + contentValue;
      }
      // action
      attributes.forEach(function (_ref) {var attr = _ref.attr,contentKey = _ref.contentKey;
        var contentValue = checkForAltAttr(attr, doctorObj[contentKey]);
        if (!hideTemplateElement(attr, contentValue)) {
          element.setAttribute(attr, contentValue);
        }
      });
    }

    function birthChildren(children) {
      children.forEach(function (kid) {return element.appendChild(createTemplateElement(kid, doctorObj));});
    }

    // Sets Css classes
    checkAndSetParameter(obj.classList, setCssClass);
    // Copies content from data to innerHTML of element
    checkAndSetParameter(obj.contentKey, setContent);
    // Sets html attributes (src, href....)
    checkAndSetParameter(obj.attributes, setAttributes);
    // loops child elemnts in template to create html structure
    checkAndSetParameter(obj.children, birthChildren);

    return element;
  }

  var GetSectionHolder = function getSectionHolder(section) {
    // internal
    function getLastChildOfClass(classname) {
      return [].slice.call(cardsHolder.querySelectorAll(classname)).pop();
    }
    // internal
    function lastCardSection() {
      return getLastChildOfClass('.doctor-cards');
    }
    // internal
    function newCardSection() {
      cardsHolder.appendChild(createTemplateElement(templateObject.heading, section));
      var cards = createTemplateElement(templateObject.cards);
      cardsHolder.appendChild(cards);
      return cards;
    }
    // internal
    function isNewSection() {
      var lastHeading = getLastChildOfClass('.doctor-cards__heading');
      return !lastHeading || lastHeading.innerHTML !== section.Group;
    }
    // action
    var sectionHolder = isNewSection() ? newCardSection() : lastCardSection();

    return {
      Append: function Append(el) {
        sectionHolder.appendChild(el);
      } };

  };

  function initializeDoctors(data, doctors, holder) {
    /*  takes global parameters and applies them to individual
                                                         cards (reused button text)                              */
    function setRepeatParameters(doc) {
      var repeatParameters = ['ReadMoreText', 'ViewProfileText'];
      repeatParameters.forEach(function (param) {
        if (data[param]) {
          doc[param] = data[param];
        }
      });

      return doc;
    }
    // action
    doctors.forEach(function (doc) {
      doc = setRepeatParameters(doc, data);
      var cardTemplate = data.HideLinks ? templateObject.noLinkCard : templateObject.card;
      holder.Append(createTemplateElement(cardTemplate, doc));
    });
  }

  function hideErrors() {
    elErrorNoResults.classList.add('u-display--none');
    elErrorBadRequest.classList.add('u-display--none');
  }

  function hasNoResults(data) {
    if (!data.Content || data.Content.length <= 0) {
      elErrorNoResults.classList.remove('u-display--none');
      return true;
    }
    return false;
  }

  function setNextUrl(urlNext, urlAll) {
    urls.next = urlNext;
    urls.all = urlAll;
  }

  function loadMoreHandler(data) {
    // internal
    var dataNextUrl = data.NextPageUrl;
    var dataAllUrl = data.AllUrl;

    function hasNextPageUrl() {
      return dataNextUrl && dataNextUrl.length > 0;
    }
    // internal
    function toggleLoadMore() {
      if (hasNextPageUrl()) {
        setNextUrl(dataNextUrl, dataAllUrl);
        loadMoreContainer.classList.remove('u-display--none');
      } else {
        loadMoreContainer.classList.add('u-display--none');
      }
    }
    // action
    stopLoadSpinner();

    if (hasNoResults(data)) {
      return;
    }

    data.Content.forEach(function (section) {
      initializeDoctors(data, section.Doctors, GetSectionHolder(section));
    });
    toggleLoadMore();
  }

  function startLoadSpinner() {
    loadSpinner.classList.remove('u-display--none');
    loadMoreContainer.classList.add('u-display--none');
  }

  function stopLoadSpinner() {
    loadSpinner.classList.add('u-display--none');
  }

  function getDoctors(url) {
    hideErrors();
    startLoadSpinner();

    try {
      ajax.get(url, {
        success: function success(data) {
          urls.next = data.NextPageUrl;
          loadMoreHandler(data);
          stopLoadSpinner();
          if (data.CardCountTotal) {
            sortNumber.innerHTML = data.CardCountTotal;
          }
        },
        error: function error(data) {
          stopLoadSpinner();
        } });

    } catch (e) {
      console.error(e);
      stopLoadSpinner();
      elErrorBadRequest.classList.remove('u-display--none');
      throw e;
    }
    // //TODO: REMOVE FOR PROD !!!!!!!!!!
    //     function tempStaticLoader(){
    //       loadMoreHandler(MocData.firstPage)
    //     }
    //     setTimeout(tempStaticLoader, 2000);
  }

  function initializeFirstLoad() {
    try {
      var url = cardsHolder.getAttribute('data-url');
      getDoctors(url);
    } catch (err) {
      console.error('OH, NO! Possible missing target elements:\n        [rel="js-cards-container] | [rel="js-load-container"]\n        causing: ' +


      err);
      //// hideErrors();
    }
    //remove next line for prod
    //loadMoreHandler(MocData.firstPage)
  }

  function loadMoreBtnHandler(e) {
    e.preventDefault();
    var loadType = e.target.getAttribute('data-load-type');
    getDoctors(urls[loadType]);
  }

  function initializeBtnListener() {
    var loadBtns = loadMoreContainer.querySelectorAll('button');
    for (var i = 0; i < loadBtns.length; i++) {
      var btn = loadBtns[i];
      btn.addEventListener('click', loadMoreBtnHandler);
    }
  }

  function Init() {
    initializeFirstLoad();
    initializeBtnListener();
  }

  Init();

})();